import { render, staticRenderFns } from "./AccountSubscription.vue?vue&type=template&id=65b7fefa"
import script from "./AccountSubscription.vue?vue&type=script&lang=js"
export * from "./AccountSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports